module.exports = __webpack_public_path__ + "static/media/SERIE10.acdeb4cb.jpg";